// src/firebase/config.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// 🔹 Your Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyAD-iS1ezpp0QpXc-1imgC8LaxTSFp7ftc",
  authDomain: "nukkad-edc40.firebaseapp.com",
  projectId: "nukkad-edc40",
  storageBucket: "nukkad-edc40.firebasestorage.app",
  messagingSenderId: "650888533807",
  appId: "1:650888533807:web:bf112ec75804139fdbb3da",
};

// 🔹 Prevent duplicate app initialization
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// 🔹 Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// 🔹 Export everything needed by the app
export { app, auth, db, storage };
